import { useShallow } from "zustand/react/shallow";
import type { Layout, SimulationParams, SpawnMode, SpeedMultiplier } from "@/features/simulation/public";
import { useSimulationStore } from "@/features/simulation/store";

/**
 * ControlsPanel が必要とする state/actions のみを抽出するセレクターフック。
 *
 * useShallow で参照同値比較し、関係ないフィールド（stats 等）の更新で再レンダしないようにする。
 * コンポーネント側に store の購読詳細を漏らさないことで、ストアスキーマ変更時の影響を局所化する。
 */
export interface SimulationControls {
  params: SimulationParams;
  layout: Layout;
  spawnMode: SpawnMode;
  running: boolean;
  speed: SpeedMultiplier;
  queuedSpawns: number;
  start: () => void;
  pause: () => void;
  reset: () => void;
  setParams: (partial: Partial<SimulationParams>) => void;
  setLayout: (partial: Partial<Layout>) => void;
  setSpawnMode: (mode: SpawnMode) => void;
  setSpeed: (s: SpeedMultiplier) => void;
  requestSpawn: () => void;
}

export function useSimulationControls(): SimulationControls {
  return useSimulationStore(
    useShallow(
      (s): SimulationControls => ({
        params: s.params,
        layout: s.layout,
        spawnMode: s.spawnMode,
        running: s.running,
        speed: s.speed,
        queuedSpawns: s.queuedSpawns,
        start: s.start,
        pause: s.pause,
        reset: s.reset,
        setParams: s.setParams,
        setLayout: s.setLayout,
        setSpawnMode: s.setSpawnMode,
        setSpeed: s.setSpeed,
        requestSpawn: s.requestSpawn,
      }),
    ),
  );
}
